import React, { PropsWithChildren } from 'react';
import {
  ANALYTICS_EVENT,
  ANALYTICS_PROPERTY,
  IntegrationName,
} from '@kouto/types';
import { analyticsManager } from 'features/analytics';
import { ErrorBoundary } from './ErrorBoundary';

const reportPageStopError = (error: Error) => {
  analyticsManager.sendEvent(
    ANALYTICS_EVENT.PAGE_STOP_ERROR,
    {
      [ANALYTICS_PROPERTY.ErrorCode]: 'system_error',
      [ANALYTICS_PROPERTY.ErrorMessage]: error.message || error.name,
    },
    { providers: [IntegrationName.ADOBE_ANALYTICS] },
  );
};

export const withErrorBoundary = <P extends JSX.IntrinsicAttributes>(
  WrappedComponent: React.ComponentType<PropsWithChildren<P>>,
) => {
  const WithErrorBoundary = (props: P) => {
    return (
      <ErrorBoundary onError={reportPageStopError}>
        <WrappedComponent {...props} />
      </ErrorBoundary>
    );
  };

  return WithErrorBoundary;
};
